/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombOfNefertitiGameModuleConfig} from "./TombOfNefertitiGameModuleConfig";

export class TombOfNefertiti extends SlotGame {

    constructor() {
        super(TombOfNefertitiGameModuleConfig.instance);
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L2",
                    "M3",
                    "L3"
                ],
                [
                    "L1",
                    "M5",
                    "L2"
                ],
                [
                    "L4",
                    "L4",
                    "L1"
                ],
                [
                    "M3",
                    "M4",
                    "M3"
                ],
                [
                    "L5",
                    "M2",
                    "L3"
                ]
            ],
            "evaluatedReels": [
                [
                    "L2",
                    "M3",
                    "L3"
                ],
                [
                    "L1",
                    "M5",
                    "L2"
                ],
                [
                    "L4",
                    "L4",
                    "L1"
                ],
                [
                    "M3",
                    "M4",
                    "M3"
                ],
                [
                    "L5",
                    "M2",
                    "L3"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWins": 0,
            "totalSpinWinningsNotMultiplied": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 0.8,
            "nearWinReels": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "respinBaseTriggeredThisSpin": false,
            "respinFSTriggeredThisSpin": false,
            "freespinPlayed": 0,
            "freespinsLeft": 0,
            "numberOfScatters": 0,
            "scatterPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "freespinRetriggered": false,
            "respinPlayed": 0,
            "respinPositionsBefore": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "respinPositionsAfter": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "payoutWinMultiplier": 1,
            "payoutMultiplierNext": 1,
            "numberOfExtraFreespinsAwarded": 0,
            "winPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "freespinMultiplierOnSpin": 1,
            "freespinMultiplierNextSpin": 1,
            "wildRaidTrigger": false,
            "wildRaidPositions": [],
            "curseOfNefertitiTrigger": false,
            "curseSymbol": "",
            "totalRespinWin": 0,
            "curseRespin": false,
            "wildPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ]
        };
    }
}